const PENDING = 'pending';
const UPLOADING = 'uploading';
const COMPLETE = 'complete';
const CANCELLED = 'cancelled';
const ERROR = 'error';

export { PENDING, UPLOADING, COMPLETE, CANCELLED, ERROR };
